import { render, staticRenderFns } from "./depositRulesPopup.vue?vue&type=template&id=4f89431e&scoped=true"
import script from "./depositRulesPopup.vue?vue&type=script&lang=js"
export * from "./depositRulesPopup.vue?vue&type=script&lang=js"
import style0 from "./depositRulesPopup.vue?vue&type=style&index=0&id=4f89431e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89431e",
  null
  
)

export default component.exports